import { FieldTypes, BelongsCreatedByRefField } from 'drapcode-constant';
const CONSTANT_ARG_NAMES = ['sessionKey'];

export const processRediretRule = (data, rowObj) => {
  const bodyData = data.map((row) => {
    if (row.id === rowObj.id) {
      row.role = rowObj.role;
      row.page = rowObj.page;
    }
    return row;
  });

  if (data[data.length - 1].id === rowObj.id) {
    let newId = rowObj.id + 1;
    let newRow = {
      id: newId,
      role: '',
      page: '',
    };
    bodyData.push(newRow);
  }
  return bodyData;
};

export const getRedirectRulesFilteredArray = (array) => {
  let filterArr = [];
  for (let i = 0; i < array.length; i++) {
    if (array[i].role && array[i].role != '' && array[i].page && array[i].page != '') {
      filterArr.push(array[i]);
    }
  }
  return filterArr;
};

export const getSessionOptions = (collections, fieldType) => {
  let options = [];
  const userCollection = collections ? collections.find((e) => e.collectionName === 'user') : null;
  if (userCollection) {
    const { fields } = userCollection;
    const nestedFields = getInnerFieldOptions(fields, collections, 'session', fieldType);
    const fieldOptions = fields
      ? fields
          .filter((e) => e.type === fieldType)
          .map((item) => {
            const fieldData = {
              fieldFrom: 'session',
              collectionName: userCollection.collectionName,
              fieldName: item.fieldName,
            };
            return {
              value: JSON.stringify(fieldData),
              label: `Current LoggedIn User:${item.fieldTitle.en}`,
            };
          })
      : [];
    options = [...fieldOptions, ...nestedFields];
  }
  return options;
};

export const getInnerFieldOptions = (fields, collections, fieldFrom, fieldType) => {
  let nestedFields = [];
  const referenceFields = fields
    ? fields.filter((field) => BelongsCreatedByRefField.includes(field.type))
    : [];
  if (referenceFields.length > 0) {
    referenceFields.map((field) => {
      if (field.type === FieldTypes.createdBy.id && !field.refCollection) {
        field.refCollection = {
          collectionName: 'user',
          collectionField: 'userName',
          displayType: 'dropdown',
        };
      }
      let { collectionName } = field.refCollection;
      let refFields = [];

      const refrenceCollection = collections
        ? collections.find((e) => e.collectionName === collectionName)
        : null;
      refFields =
        refrenceCollection && refrenceCollection.fields
          ? refrenceCollection.fields
              .filter((e) => e.type === fieldType)
              .map((nestedField) => {
                const fieldData = {
                  fieldFrom: fieldFrom,
                  fieldName: field.fieldName + '.' + nestedField.fieldName,
                  collectionName: refrenceCollection.collectionName,
                };
                return {
                  value: JSON.stringify(fieldData),
                  label:
                    fieldFrom === 'session'
                      ? `Current LoggedIn User:${field.fieldTitle.en}:${nestedField.fieldTitle.en}`
                      : field.fieldTitle.en + ':' + nestedField.fieldTitle.en,
                };
              })
          : [];
      nestedFields = [...nestedFields, ...refFields];
    });
  }
  return nestedFields;
};

export const getEventCollectionFieldOptions = (eventCollectionName, collections, fieldType) => {
  let options = [];
  const eventCollection = collections
    ? collections.find((e) => e.collectionName === eventCollectionName)
    : null;
  if (eventCollection) {
    const { fields } = eventCollection;
    const nestedFields = getInnerFieldOptions(fields, collections, 'eventCollection', fieldType);
    const fieldOptions = fields
      ? fields
          .filter((e) => e.type === fieldType)
          .map((item) => {
            const fieldData = {
              fieldFrom: 'eventCollection',
              collectionName: eventCollection.collectionName,
              fieldName: item.fieldName,
            };
            return {
              value: JSON.stringify(fieldData),
              label: item.fieldTitle.en,
            };
          })
      : [];
    options = [...fieldOptions, ...nestedFields];
  }
  return options;
};

export const handleConstantActionParams = (args, schema, dbParameters) => {
  if (CONSTANT_ARG_NAMES.includes(args.name)) {
    schema[args.name] = dbParameters ? dbParameters.value : args.value ? args.value : '';
  } else {
    schema[args.name] = dbParameters ? dbParameters.value : '';
  }
};

export const collectionItemOption = {
  value: JSON.stringify({
    fieldFrom: 'currentCollectionItem',
    collectionName: 'PARENT_COLLECTION',
    fieldName: 'ITEM_ID',
  }),
  label: 'Id',
};
export const pageCollectionOption = {
  value: JSON.stringify({
    fieldFrom: 'session',
    collectionName: 'PAGE_COLLECTION',
    fieldName: 'ITEM_ID',
  }),
  label: 'Current Page Item Id',
};
export const previousStepOption = {
  value: JSON.stringify({
    fieldFrom: 'previousStepCollectionItemId',
    collectionName: 'PREVIOUS_STEP_COLLECTION',
    fieldName: 'ITEM_ID',
  }),
  label: 'Previous Step Item Id',
};
